import Cookie from "js-cookie";

const TOKEN_KEY = 'pui_token';
const TENANT_ID_KEY = 'pui_tenant_id';
const SCHOOL_ID_KEY = 'pui_school_id';
const domain = import.meta.env.VITE_APP_DOMAIN;

export const Storage = {
	getToken(): string {
		return Cookie.get(TOKEN_KEY) || '';
		// return localStorage.getItem(TOKEN_KEY) || '';
	},
	setToken(token: string) {
		const options: any = { expires: 1, path: "/" };
		if (domain) options.domain = domain;
		Cookie.set(TOKEN_KEY, token, options);
		// localStorage.setItem(TOKEN_KEY, token || '');
		if (typeof window !== 'undefined') window.dispatchEvent(new Event('pui-auth-changed'));
	},
	clearToken() {
		const options: any = { path: "/" };
		if (domain) options.domain = domain;
		Cookie.remove(TOKEN_KEY, options);
		Cookie.remove(TOKEN_KEY, { path: "/" });
		// localStorage.removeItem(TOKEN_KEY);
		if (typeof window !== 'undefined') window.dispatchEvent(new Event('pui-auth-changed'));
	},
	getTenantId(): string {
		return localStorage.getItem(TENANT_ID_KEY) || '';
	},
	setTenantId(tenantId: string) {
		localStorage.setItem(TENANT_ID_KEY, tenantId || '');
	},
	clearTenantId() {
		localStorage.removeItem(TENANT_ID_KEY);
	},
	getSchoolId(): string {
		return localStorage.getItem(SCHOOL_ID_KEY) || '';
	},
	setSchoolId(schoolId: string) {
		localStorage.setItem(SCHOOL_ID_KEY, schoolId || '');
	},
	clearSchoolId() {
		localStorage.removeItem(SCHOOL_ID_KEY);
	},
};
